/**
 * Contains action-only routes for the my scores (home) route
 */
import { RouteObject } from 'react-router-dom'

import updateCollectionOrderAction from '@pages/home/actions/collection/updateCollectionOrder.action'

import addToCollectionAction from './addToCollection.action'
import addCollectionAction from './collection/addCollection.action'
import deleteCollectionAction from './collection/deleteCollection.action'
import updateCollectionAction from './collection/updateCollection.action'
import copyToSiteAction from './copyToSite.action'
import deleteScoresAction from './deleteScores.action'
import removeFavoritesAction from './removeFavorites.action'
import removeFromCollectionAction from './removeFromCollection.action'
import removeScoresAction from './removeScores.action'
import removeSharedScoresAction from './removeSharedScores.action'
import restoreScoresAction from './restoreScores.action'

const actionRoutes: RouteObject[] = [
  {
    path: 'deleteScores',
    action: deleteScoresAction,
  },
  {
    path: 'restoreScores',
    action: restoreScoresAction,
  },
  {
    path: 'addToCollection',
    action: addToCollectionAction,
  },
  {
    path: 'addCollection',
    action: addCollectionAction,
  },
  {
    path: 'updateCollection',
    action: updateCollectionAction,
  },
  {
    path: 'updateCollectionOrder',
    action: updateCollectionOrderAction,
  },
  {
    path: 'deleteCollection',
    action: deleteCollectionAction,
  },
  {
    path: 'copyToSite',
    action: copyToSiteAction,
  },
  {
    path: 'removeFromCollection',
    action: removeFromCollectionAction,
  },
  {
    path: 'removeFavorites',
    action: removeFavoritesAction,
  },
  {
    path: 'removeSharedScores',
    action: removeSharedScoresAction,
  },
  {
    path: 'removeScores',
    action: removeScoresAction,
  },
]

export default actionRoutes
